const angular = require('angular');
var dragula = require('../../../../node_modules/dragula/dragula');
const app = angular.module('learn-directives');
/**
 * Defines the Assessment Question Builder Component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('questionBuilder', ['Application', 'AssessmentLib', '$translate', function (Application, AssessmentLib, $translate) {
  return {
    restrict: 'E',
    scope: {
      assessment: '=',
      save: '&',
      done: '&',
      question: '='
    },
    template: require('../../../templates/directives/assessments/question-builder.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      $scope.triggervid = {};
      $scope.loadingbar = false;

      self.info = {
        selectionNumber: 1,
        manualPoints: 1,
        wordLimit: 5000,
        wordMinimum: 0,
        editQuestion: {},
        newQuestion: false,
        formatOptions: [],
        optionAvailability: {
          randomize_choice_order: {
            multiple_choice: true,
            dropdown: true,
            checkbox: true
          },
          multiple_selections: {
            multiple_choice: true,
            checkbox: true,
            short_input: true
          },
          max_value_is_total: {
            multiple_choice: true,
            checkbox: true,
            short_input: true
          },
          question_value_is_custom: {
            multiple_choice: true,
            checkbox: true,
            short_input: true
          },
          number_of_selections: {
            multiple_choice: true,
            checkbox: true,
            short_input: true
          },
          manual_grade: {
            short_input: true
          },
          word_limit: {
            long_input: true
          },
          word_minimum: {
            long_input: true
          }
        },
        someOptions: {
          multiple_choice: true,
          dropdown: true,
          checkbox: true,
          short_input: true  
        },
        noChoices: {
          long_input: true
        },
        initialize: function() {
          if (!$scope.question || typeof $scope.question !== 'object') {
            return;
          }
          self.info.newQuestion = false;
          if ($scope.question.newQuestion) {
            self.info.newQuestion = true;
          }
          delete $scope.question.newQuestion;

          self.info.editQuestion = Object.assign({}, $scope.question);
          if (!self.info.editQuestion.format) {
            delete self.info.editQuestion.format;
            setTimeout(function() {
              self.info.editQuestion.format = 'multiple_choice';
              $scope.$apply();
            }, 1);
          }
          self.question.parseOptions();
          self.choices.init();
          if (self.info.editQuestion.question_asset) {
            self.question_asset.adding = true;
          }
        },
        save: function() {
          if (!self.info.editQuestion || !self.info.editQuestion.format) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.select_question_format']});
            return;
          }

          if (!self.info.editQuestion.question) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.question_input']});
            return;
          }

          if (!self.question.getOption('manual_grade')) {
            if (self.info.editQuestion.format === 'short_input') {
              if (!self.info.editQuestion.choice_options || self.info.editQuestion.choice_options.length < 1) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.input_required']});
                return;
              }
            } else if (!self.info.editQuestion.choice_options || self.info.editQuestion.choice_options.length < 2) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.answers_required']});
              return;
            }

            var manualPoints;
            var availableSelections = 1;
            if (self.question.getOption('multiple_selections')) {
              availableSelections = self.question.getOption('number_of_selections');
            }
            // Make sure 1) points are available and 2) all options have copy
            var needCopy = false;
            var totalCreatedPoints = 0;
            var totalSelectablePoints = 0;
            var pointsList = [];
            for (var i = 0; i < self.info.editQuestion.choice_options.length; i++) {
              if (self.info.editQuestion.choice_options[i].points) {
                pointsList.push(self.info.editQuestion.choice_options[i].points);
                totalCreatedPoints += self.info.editQuestion.choice_options[i].points;
              }
              if (!self.info.editQuestion.choice_options[i].copy) {
                needCopy = true;
              }
            }
            if (!pointsList.length) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.one_correct']});
              return;
            }
            if (needCopy) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.text_required']});
              return;
            }

            if (self.question.getOption('max_value_is_total') && !self.question.getOption('multiple_selections') && pointsList.length > 1) {
              // if set to max total make sure there are enough selectable points
              Application.messaging.addMessage({type: 'error', duration: 8, text: self.translations['edit.assessment.over_max']});
              return;
            }

            if (self.question.getOption('multiple_selections')) {
              // Find the number of allowed selections and set the max total to the sum of the highest matching point values
              pointsList.sort(function (a, b) {
                return b - a;
              });

              pointsList.forEach(function(item, index) {
                if (index >= availableSelections) {
                  return;
                }
                totalSelectablePoints += item;
              });
              // if set to custom value make sure there are points and they are <= to total available
              if (self.question.getOption('question_value_is_custom')) {
                manualPoints = self.question.getOption('manual_points');
                if (!manualPoints) {
                  Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.set_value']});
                  return;
                }
                if (totalSelectablePoints < manualPoints) {
                  Application.messaging.addMessage({type: 'error', duration: 8, text: self.translations['edit.assessment.under_min']});
                  return;
                }
              }

              // if set to max total make sure there are enough selectable points
              if (self.question.getOption('max_value_is_total')) {
                if (totalSelectablePoints < totalCreatedPoints) {
                  Application.messaging.addMessage({type: 'error', duration: 8, text: self.translations['edit.assessment.over_max']});
                  return;
                }
              }
            }

          }

          if (self.question.getOption('manual_grade')) {
            var points = self.question.getOption('manual_points');
            if (!points) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.add_points']});
              return;
            }
          }

          $scope.save({question: self.info.editQuestion});
          Application.scrollTop();
        },
        cancel: function() {
          Application.scrollTop();
          $scope.done();
        },
        sortByProp: function(arr, prop) {
          arr.sort(function(a, b) {
            if (a[prop] > b[prop]) {
              return 1;
            }
            if (a[prop] < b[prop]) {
              return -1;
            }
            return 0;
          });
        }
      };

      self.question_asset = {
        adding: false,
        imageChange: function() {
          if (!self.info.editQuestion.question_asset) {
            self.info.editQuestion.question_asset_type = '';
            $scope.$apply();
          }
        },
        videoChange: function() {
          if (!self.info.editQuestion.question_asset) {
            self.info.editQuestion.question_asset_type = '';
            $scope.$apply();
          }
        }
      };

      self.question = {
        toggleOptions: false,
        parseOptions: function() {
          if (!self.info.editQuestion || !self.info.editQuestion.question_options) {
             return;
          }
          self.info.editQuestion.question_options.forEach(function(item) {
            if (item.name === 'number_of_selections') {
              self.info.selectionNumber = item.value;
            }
            if (item.name === 'manual_points') {
              self.info.manualPoints = item.value;
            }
            if (item.name === 'word_limit') {
              self.info.wordLimit = item.value;
            }
            if (item.name === 'word_minimum') {
              self.info.wordMinimum = item.value;
            }
            if (item.name === 'multiple_selections') {
              self.question.multipleSelections = item.value;
            }
            if (item.name === 'randomize_choice_order') {
              self.question.randomChoiceOrder = item.value;
            }
            if (item.name === 'multiple_selections') {
              self.question.multipleSelections = item.value;
            }
            if (item.name === 'max_value_is_total') {
              self.question.maxValueIsTotal = item.value;
            }
            if (item.name === 'question_value_is_custom') {
              self.question.customQuestionValue = item.value;
            }
          });
        },
        setOption: function(type, value) {
          if (!self.info.editQuestion) {
            return null;
          }
          if (!self.info.editQuestion.question_options) {
            self.info.editQuestion.question_options = [];
          }
          for (var i = 0; i < self.info.editQuestion.question_options.length; i++) {
            if (self.info.editQuestion.question_options[i] && self.info.editQuestion.question_options[i].name === type) {
              self.info.editQuestion.question_options[i].value = value;
              return;
            }
          }
          self.info.editQuestion.question_options.push({name: type, value: value});
        },
        getOption: function(type) {
          if (!self.info.editQuestion) {
            return null;
          }
          if (!self.info.editQuestion.question_options) {
            self.info.editQuestion.question_options = [];
            return null;
          }
          for (var i = 0; i < self.info.editQuestion.question_options.length; i++) {
            if (self.info.editQuestion.question_options[i] && self.info.editQuestion.question_options[i].name === type) {
              return self.info.editQuestion.question_options[i].value;
            }
          }
        },
        maxPoints: function() {
          return AssessmentLib.helpers.getQuestionValue(self.info.editQuestion);
        },
        swapBooleanOption: function(type, value) {
          if (self.question.getOption(type)) {
            self.question.setOption(type, false);
            return;
          }

          if (type === 'question_value_is_custom') {
            self.question.setOption('max_value_is_total', false);
          }

          if (type === 'max_value_is_total') {
            self.question.setOption('question_value_is_custom', false);
          }

          self.question.setOption(type, true);
        },
        selectionNumberChange: function(add) {
          if (!self.info.editQuestion.choice_options || !self.info.editQuestion.choice_options.length) {
            return;
          }
          var maxOptions = 0;
          self.info.editQuestion.choice_options.forEach(function(item) {
            if (item.points) {
              maxOptions++;
            }
          });
          if (add && self.info.selectionNumber < maxOptions) {
            self.info.selectionNumber++;
          }
          if (!add && self.info.selectionNumber > 1) {
            self.info.selectionNumber--;
          }
          self.question.selectionNumberUpdate();
        },
        selectionNumberUpdate: function() {
          self.question.setOption('number_of_selections', self.info.selectionNumber);
        },
        manualPointsChange: function(add) {
          if (add) {
            self.info.manualPoints++;
          }
          if (!add && self.info.manualPoints > 1) {
            self.info.manualPoints--;
          }
          self.question.manualPointsUpdate();
        },
        manualPointsUpdate: function() {
          self.question.setOption('manual_points', self.info.manualPoints);
        },
        wordLimitUpdate: function() {
          if (self.info.wordLimit < 10) {
            self.info.wordLimit = 10;
          }
          self.question.setOption('word_limit', self.info.wordLimit);
            if (parseInt(self.info.wordMinimum) > parseInt(self.info.wordLimit)) {
              var testValue = parseInt(self.info.wordLimit) - 100;
              self.info.wordMinimum = testValue > 0 ? testValue : 0;
              self.question.wordMinimumUpdate();
            }
        },
        wordMinimumUpdate: function() {
          self.question.setOption('word_minimum', self.info.wordMinimum);
            if (parseInt(self.info.wordMinimum) > parseInt(self.info.wordLimit)) {
              var testValue = parseInt(self.info.wordMinimum) + 100;
              self.info.wordLimit = testValue < 5000 ? testValue : 5000;
              self.question.wordLimitUpdate();
            }
        },
        multipleSelections: false,
        multipleSelectionsChange: function() {
          if (self.question.getOption('multiple_selections') !== self.question.multipleSelections) {
            if (!self.question.multipleSelections) {
              // unset selection values
              self.info.selectionNumber = 1;
              self.question.selectionNumberUpdate();
            }
            self.question.swapBooleanOption('multiple_selections');
          }
        },
        randomChoiceOrder: false,
        randomChoiceOrderChange: function() {
          if (self.question.getOption('randomize_choice_order') !== self.question.randomChoiceOrder) {
            self.question.swapBooleanOption('randomize_choice_order');
          }
        },
        maxValueIsTotal: false,
        maxValueIsTotalChange: function() {
          if (self.question.getOption('max_value_is_total') !== self.question.maxValueIsTotal) {
            self.question.swapBooleanOption('max_value_is_total');
          }
          if (self.question.getOption('max_value_is_total')) {
            self.question.customQuestionValue = false;
            self.question.customQuestionValueChange();
          }
        },
        customQuestionValue: false,
        customQuestionValueChange: function() {
          if (self.question.getOption('question_value_is_custom') !== self.question.customQuestionValue) {
            self.question.swapBooleanOption('question_value_is_custom');
          }
          if (self.question.getOption('question_value_is_custom')) {
            self.question.maxValueIsTotal = false;
            self.question.maxValueIsTotalChange();
            if (!self.question.getOption('manual_points')) {
              self.question.setOption('manual_points', 1);
              self.info.manualPoints = 1;
            }
          }
        }
      };

      self.choices = {
        dragId: AssessmentLib.helpers.makeId(),
        dragManagement: null,
        init: function() {
          if (!self.info.editQuestion.choice_options) {
            self.info.editQuestion.choice_options = [];
          }
          if (!self.info.editQuestion.choice_options.length) {
            for (var i = 0; i < 3; i++) {
              self.choices.add();
            }
            setDrag();
          } else {
            // parse existing choice options
            self.info.sortByProp(self.info.editQuestion.choice_options, 'position');
            setDrag();
          }
        },
        add: function() {
          if (self.info.editQuestion.choice_options.length >= 8) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.max_choices']});
            return;
          }
          self.info.editQuestion.choice_options.push({
            copy: '',
            points: self.info.editQuestion.format === 'short_input' ? 1 : 0,
            image: null,
            position: self.info.editQuestion.choice_options.length,
            id: AssessmentLib.helpers.makeId()
          });
          return;
        },
        getById: function(id) {
          for (var i = 0; i < self.info.editQuestion.choice_options.length; i++) {
            if (self.info.editQuestion.choice_options[i].id === id) {
              return self.info.editQuestion.choice_options[i];
            }
          }
          return null;
        },
        points: function(add, item) {
          var choice = self.choices.getById(item && item.id || null);
          if (!choice || typeof choice.points !== 'number') {
            return;
          }
          if (!add) {
            if (self.info.editQuestion.format === 'short_input' && choice.points === 1) {
              return;
            }
            if (choice.points === 0) {
              return;
            }
            choice.points--;
            return;
          }
          choice.points++;
        },
        toggle: function(item) {
          if (self.info.editQuestion.format === 'short_input') {
            return;
          }
          var choice = self.choices.getById(item && item.id || null);
          if (!choice || typeof choice.points !== 'number') {
            return;
          }
          if (choice.points > 0) {
            choice.points = 0;
            let optionCount = 0;
            if (self.info.editQuestion.choice_options.length) {
              self.info.editQuestion.choice_options.forEach(item => {
                if (item.points) {
                  optionCount++;
                }
              });
            }
            if (optionCount < 2) {
              self.info.selectionNumber = 1;
              self.question.selectionNumberUpdate();
            }
            if (optionCount < self.info.selectionNumber) {
              self.info.selectionNumber = optionCount;
              self.question.selectionNumberUpdate();
            }
            return;
          }
          choice.points = 1;
        },
        remove: function(item) {
          if (!item || !item.id || self.info.editQuestion.choice_options.length < 3 && self.info.editQuestion.format !== 'short_input') {
            Application.messaging.addMessage({type: 'error', text: self.translations['edit.assessment.two_required'], duration: 5});
            return;
          }
          if (self.info.editQuestion.format === 'short_input') {
            if (self.info.editQuestion.choice_options.length === 1) {
              Application.messaging.addMessage({type: 'error', text: self.translations['edit.assessment.input_required'], duration: 5});
              return;
            }
          }
          var adjustPositions = function(position) {
            self.info.editQuestion.choice_options.forEach(function(item) {
              if (item.position > position) {
                item.position--;
              }
            });
          };
          for (var i = 0; i < self.info.editQuestion.choice_options.length; i++) {
            if (item.id === self.info.editQuestion.choice_options[i].id) {
              self.info.editQuestion.choice_options.splice(i, 1);
              adjustPositions(i);
              return;
            }
          }
        },
        multipleCorrect: function() {
          if (!self.info.editQuestion.choice_options || !self.info.editQuestion.choice_options.length) {
            return false;
          }
          var correct = 0;
          for (var i = 0; i < self.info.editQuestion.choice_options.length; i++) {
            if (self.info.editQuestion.choice_options[i].points) {
              correct++;
              if (correct > 1) {
                return true;
              }
            }
          }
          return false;
        }
      };

      var setDrag = function() {
        setTimeout(function() {
          self.choices.dragManagement = dragula({
            direction: 'vertical',
            mirrorContainer: document.querySelectorAll('#mirror-' + self.choices.dragId)[0]
          });
        }, 5);
      };

      $scope.$watch('builder.info.editQuestion.format', function(newVal, oldVal) {
        if (newVal && !oldVal || newVal !== oldVal) {
          if (!self.ignoreFormat) {
            self.question.setOption('question_value_is_custom', false);
            self.question.setOption('manual_grade', false);
            self.question.setOption('multiple_selections', false);
            self.question.setOption('max_value_is_total', false);
            self.question.setOption('randomize_choice_order', false);
            self.question.setOption('number_of_selections', 1);
            self.question.setOption('manual_points', null);
            self.question.setOption('grader_instructions', '');
            self.question.multipleSelections = false;
            self.question.randomChoiceOrder = false;
            self.question.maxValueIsTotal = false;
            self.question.customQuestionValue = false;

            if (self.info.editQuestion.format === 'long_input') {
              self.question.setOption('manual_points', 1);
              self.question.setOption('manual_grade', true);
              self.question.setOption('word_limit', 5000);
              self.question.setOption('word_minimum', 0);
              return;
            }

            if (self.info.editQuestion.format === 'short_input') {
              if (self.info.editQuestion.choice_options && self.info.editQuestion.choice_options.length) {
                self.question.setOption('manual_grade', false);
                self.info.editQuestion.choice_options.forEach(function(item) {
                  if (!item.points) {
                    item.points = 1;
                  }
                });
              } else {
                self.question.setOption('manual_grade', true);
                self.question.setOption('manual_points', 1);
              }
            }
          }

          self.ignoreFormat = false;

          if (self.info.editQuestion.choice_options && self.info.editQuestion.choice_options.length && !self.question.getOption('manual_grade')) {
            setTimeout(function() {
              self.choices.dragManagement.containers = [];
              var selected = document.querySelectorAll('#choice-' + self.choices.dragId);
              for (var i = 0; i < selected.length; i++) {
                self.choices.dragManagement.containers.push(selected[i]);
              }
              self.choices.dragManagement.on('drop', function(el, target, source, sibling) {
                var selected = document.querySelectorAll('#choice-' + self.choices.dragId)[0];
                var newOrder = [];
                for (var i = 0; i < selected.children.length; i++) {
                  newOrder.push(selected.children[i].id);
                }

                self.info.editQuestion.choice_options.forEach(function(item) {
                  item.position = newOrder.indexOf(item.id);
                });

                self.info.sortByProp(self.info.editQuestion.choice_options, 'position');
              });
            }, 5)
          }
        }
      });

      $translate([
        'edit.assessment.select_question_format',
        'edit.assessment.question_input',
        'edit.assessment.input_required',
        'edit.assessment.answers_required',
        'edit.assessment.one_correct',
        'edit.assessment.text_required',
        'edit.assessment.over_max',
        'edit.assessment.set_value',
        'edit.assessment.under_min',
        'edit.assessment.add_points',
        'edit.assessment.max_choices',
        'edit.assessment.two_required',
        'edit.assessment.multiple_choice',
        'edit.assessment.checkboxs',
        'edit.assessment.dropdown',
        'edit.assessment.single_input',
        'edit.assessment.long_input'
      ]).then(function(translations) {
        self.translations = translations;
        self.info.formatOptions = [
          {
            name: self.translations['edit.assessment.multiple_choice'],
            value: 'multiple_choice'
          }, {
          //   name: 'Checkboxes',
          //   value: 'checkbox'
          // }, {
            name: self.translations['edit.assessment.dropdown'],
            value: 'dropdown'
          }, {
            name: self.translations['edit.assessment.single_input'],
            value: 'short_input'
          }, {
            name: self.translations['edit.assessment.long_input'],
            value: 'long_input'
          }
        ];
      });

      $scope.$watch('question', function(newVal, oldVal) {
        self.info.initialize();
        self.ignoreFormat = true;
        setTimeout(function() {
          self.ignoreFormat = false;
        }, 100);
      });

      if ($scope.question) {
        self.info.initialize();
        self.ignoreFormat = true;
        setTimeout(function() {
          self.ignoreFormat = false;
        }, 100);
      }

    }],
    controllerAs: 'builder'
  };
}]);